<template>
  <div class="option-list">
    <!-- 字段名称 -->
    <div class="field-name-row">
      <span class="required">*</span>
      <span>字段名称</span>
      <el-input v-model="localData.fieldName" placeholder="" class="field-name-input" @change="emitData"></el-input>
    </div>

    <!-- 分割线 -->
    <div class="divider"></div>

    <!-- 表头 -->
    <div class="table-header">
      <div class="header-condition">
        <span class="required">*</span>
        <span>条件（运营在创建模板时可单选其中之一）</span>
      </div>
      <div class="header-sale">
        <span class="required">*</span>
        <span>销售提成</span>
      </div>
      <div class="header-manager">
        <span class="required">*</span>
        <span>经理管理佣金</span>
      </div>
      <div class="header-director">
        <span class="required">*</span>
        <span>总监管理佣金</span>
      </div>
      <div class="header-empty"></div>
    </div>

    <!-- 条件列表 -->
    <div class="condition-list">
      <div v-for="(item, index) in localData.conditions" :key="index" class="condition-row">
        <el-input v-model="item.optionName" placeholder="" class="condition-input" @change="emitData"></el-input>
        <span class="equals">=</span>
        <el-input v-model="item.saleRoyalty" placeholder="" class="percent-input" @input="handlePercentInput($event, index, 'saleRoyalty')" >
          <template slot="append">%</template>
        </el-input>
        <el-input v-model="item.managerRoyalty" placeholder="" class="percent-input" @input="handlePercentInput($event, index, 'managerRoyalty')" >
          <template slot="append">%</template>
        </el-input>
        <el-input v-model="item.directorRoyalty" placeholder="" class="percent-input" @input="handlePercentInput($event, index, 'directorRoyalty')" >
          <template slot="append">%</template>
        </el-input>
        <div class="remove-btn-wrapper">
          <span class="remove-btn" @click="removeCondition(index)">
            <i class="el-icon-remove-outline"></i> 移除本选项
          </span>
        </div>
      </div>
    </div>

    <!-- 增加条件按钮 -->
    <div class="add-btn-wrapper">
      <el-button type="text" @click="addCondition" class="add-btn">
        <i class="el-icon-circle-plus-outline"></i> 增加1个条件
      </el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OptionList',
  props: {
    optionList: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      localData: {
        fieldName: null,
        conditions: []
      }
    }
  },
  watch: {
    optionList: {
      immediate: true,
      handler(val) {
        if (val && val.conditions) {
          this.localData = {
            fieldName: val.fieldName || null,
            conditions: JSON.parse(JSON.stringify(val.conditions))
          }
        } else {
          this.localData = {
            fieldName: null,
            conditions: [this.createEmptyCondition()]
          }
        }
      }
    }
  },
  methods: {
    createEmptyCondition() {
      return {
        optionName: null,
        saleRoyalty: null,
        managerRoyalty: null,
        directorRoyalty: null
      }
    },
    addCondition() {
      this.localData.conditions.push(this.createEmptyCondition())
      this.emitData()
    },
    removeCondition(index) {
      if (this.localData.conditions.length > 1) {
        this.localData.conditions.splice(index, 1)
        this.emitData()
      }
    },
    emitData() {
      this.$emit('update:optionList', { ...this.localData })
      this.$emit('change', { ...this.localData })
    },
    handlePercentInput(value, index, field) {
      // 只允许数字和小数点
      let val = value.replace(/[^0-9.]/g, '')
      // 去除前导零
      val = val.replace(/^0+(?=\d)/, '')
      // 只允许一个小数点
      val = val.replace(/(\..*)\./g, '$1')
      // 最多两位小数
      val = val.replace(/(\..{2})./g, '$1')
      // 最大值限制为100
      if (parseFloat(val) > 100) {
        val = '100'
      }
      // 更新数据
      this.localData.conditions[index][field] = val
    },
    validate() {

      console.log(this.localData, 'localData');

      if (!this.localData.fieldName || this.localData.fieldName.trim() === '') {
        this.$notify({ message: '字段名称不能为空', type: 'warning' })
        return false
      }
      for (let i = 0; i < this.localData.conditions.length; i++) {
        const item = this.localData.conditions[i]
        if (!item.optionName || item.optionName.trim() === '') {
          this.$notify({ message: `第${i + 1}个条件的选项名称不能为空`, type: 'warning' })
          return false
        }
        if (item.saleRoyalty == null || item.saleRoyalty === '') {
          this.$notify({ message: `第${i + 1}个条件的销售提成不能为空`, type: 'warning' })
          return false
        }
        if (item.managerRoyalty == null || item.managerRoyalty === '') {
          this.$notify({ message: `第${i + 1}个条件的经理管理佣金不能为空`, type: 'warning' })
          return false
        }
        if (item.directorRoyalty == null || item.directorRoyalty === '') {
          this.$notify({ message: `第${i + 1}个条件的总监管理佣金不能为空`, type: 'warning' })
          return false
        }
      }
      return true
    }
  }
}
</script>

<style scoped>
.option-list {
  width: 850px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  padding: 20px;
  background: #fff;
  margin-left: 170px;
}

.field-name-row {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}

.required {
  color: #f56c6c;
  margin-right: 4px;
}

.field-name-input {
  width: 250px;
  margin-left: 10px;
}

.divider {
  border-top: 1px solid #dcdfe6;
  margin: 15px 0;
}

.table-header {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  font-size: 14px;
  color: #606266;
}

.header-condition {
  width: 220px;
}

.header-sale,
.header-manager,
.header-director {
  width: 130px;
  text-align: center;
}

.header-empty {
  width: 100px;
}

.condition-list {
  margin-bottom: 15px;
}

.condition-row {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.condition-input {
  width: 200px;
}

.equals {
  width: 20px;
  text-align: center;
  color: #606266;
  font-weight: bold;
}

.percent-input {
  width: 130px;
  text-align: center;
  margin-right: 12px;
}

.remove-btn-wrapper {
  width: 100px;
  text-align: center;
}

.remove-btn {
  color: #409eff;
  cursor: pointer;
  font-size: 14px;
}

.remove-btn:hover {
  color: #66b1ff;
}

.remove-btn i {
  margin-right: 4px;
}

.add-btn-wrapper {
  text-align: center;
  margin-top: 15px;
}

.add-btn {
  color: #409eff;
}

.add-btn i {
  margin-right: 4px;
}
</style>
